import React, { createContext, useState, useCallback, useContext, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Toaster } from '../Toaster.js';

let toastCounter = 0;
const ToastContext = createContext(null);
const ToastPortal = ({ children }) => {
    const [toastElement, setElement] = useState(null);
    useEffect(() => {
        const toastContainerId = 'leafwell-toast-container';
        let element = document.getElementById(toastContainerId);
        if (!element) {
            element = document.createElement('div');
            element.setAttribute('id', toastContainerId);
            document.body.appendChild(element);
        }
        setElement(element);
    }, []);
    if (!toastElement) {
        return null;
    }
    return createPortal(children, toastElement);
};
const ToastProvider = ({ children, }) => {
    const [toasts, updateToasts] = useState([]);
    const addToast = useCallback((toast) => {
        updateToasts(toasts => [
            ...toasts.filter(prevToast => prevToast.key !== toast.key),
            {
                ...toast,
                id: `${toastCounter++}`,
            },
        ]);
    }, []);
    const removeToast = useCallback((id) => {
        updateToasts(toasts => toasts.filter(toast => toast.id !== id));
    }, []);
    return (React.createElement(ToastContext.Provider, { value: { addToast, removeToast } },
        children,
        React.createElement(ToastPortal, null,
            React.createElement(Toaster, { toasts: toasts }))));
};
const useToast = () => {
    const toastContext = useContext(ToastContext);
    if (toastContext === null) {
        throw new Error('No "ToastProvider" configured');
    }
    return toastContext;
};

export { ToastProvider, useToast };
//# sourceMappingURL=useToast.js.map
